// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"80ef355e","24":"ee58d9b0","48":"b2db1d20","56":"1ec6b140","170":"de73b7ba","617":"99bd1ddd","624":"cdbf4119","869":"afa67718"}[chunkId] + ".css";
};